import type { ReactNode } from 'react';

/**
 * The layout frame.
 *
 * Layout only. It places a header, a main region and a skip link; it decides
 * nothing about meaning, trust, failure or permission (FE-1 Stage Work Item §7.4 —
 * "Components render. The domain layer owns business semantics.").
 */

export interface LayoutFrameProps {
  readonly children: ReactNode;
}

export function LayoutFrame({ children }: LayoutFrameProps) {
  return (
    <div className="fe1w0-shell">
      <a className="fe1w0-shell__skip" href="#fe1w0-main">
        Skip to main content
      </a>
      <header className="fe1w0-shell__header">
        <p className="fe1w0-shell__title">National AI Fire Service Platform</p>
        <p className="fe1w0-shell__subtitle">FE1-W0 Frontend Foundation — Non-Operational</p>
      </header>
      <main className="fe1w0-shell__main" id="fe1w0-main" tabIndex={-1}>
        {children}
      </main>
    </div>
  );
}
